import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Cell } from 'fixed-data-table-2'
import classnames from 'classnames/bind'
import * as formatters from '../utils/formatters'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const { formatFilter } = formatters

const renderValue = (value, { optionList }) => formatFilter(value, optionList)

const FilterCell = props => {
  const { rowIndex, definition, data, ...restProps } = props
  const { field } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const row = data[rowIndex]

  return (
    <Cell
      data-elm-id={`${baseField}_${rowIndex}`}
      className={cx('cell')}
      {...restProps}
    >
      <div
        style={{ width: DataTableUtils.getCellInnerWidth(definition.colProps) }}
        className={cx('text-truncate')}
      >
        {renderValue(
          _.get(row, field) || row[baseField],
          definition.formatOptions || {}
        )}
      </div>
    </Cell>
  )
}

/**
 * value expected for FilterCell would have is_equals and is_not_equals arrays of strings
 * e.g. {
 *  is_equals: ['CAS', 'CSM', 'CAK'],
 *  is_not_equals: ['KWE],
 * }
 *
 * formatOptions for FilterCell allow for different filter format functions with optional arguments.
 * e.g. formatOptions: {
 *  optionList: [
 *    {
 *      value: 'test',
 *      text: 'test',
 *    }
 *  ]
 * }
 */

FilterCell.propTypes = {
  rowIndex: PropTypes.number,
  definition: PropTypes.shape({
    colProps: PropTypes.object.isRequired,
    field: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    formatOptions: PropTypes.shape({
      optionList: PropTypes.array,
    }),
  }).isRequired,
  data: PropTypes.array,
}

export default FilterCell
